/* Native option-value selection; full matrices are never needed for large products. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.nativeOptionsReady || root.dataset.variantResolver !== 'server') return;
    const form = root.querySelector('form[action*="/cart/add"]');
    const id = form?.querySelector('[name="id"]');
    const groups = [...root.querySelectorAll('[data-native-option-position]')];
    const status = root.querySelector('[data-native-option-status]');
    const retry = root.querySelector('[data-native-option-retry]');
    if (!id || !groups.length || !status || !retry) return;
    root.dataset.nativeOptionsReady = 'true';
    let messages = {};
    try { messages = JSON.parse(document.getElementById('Cover11ShoppingConfig').textContent).messages || {}; } catch (_) {}
    let revision = 0, controller, nextAllowedAt = 0;
    const publish = variants => root.dispatchEvent(new CustomEvent('cover11:variant-data', {detail: variants}));
    async function update() {
      const current = ++revision;
      controller?.abort();
      controller = new AbortController();
      const requestController = controller;
      const timeout = setTimeout(() => requestController.abort(), 12000);
      const inputs = groups.map(group => group.querySelector('input:checked'));
      const optionIds = inputs.map(input => input?.dataset.nativeOptionId || '');
      root.dataset.variantLoading = 'true';
      id.value = '';
      root.setAttribute('aria-busy', 'true');
      retry.hidden = true;
      retry.disabled = false;
      status.textContent = messages.checking_options || '';
      publish([]);
      try {
        if (optionIds.some(value => !/^\d+$/.test(value))) throw new Error('selection');
        await new Promise(resolve => setTimeout(resolve, 150));
        if (current !== revision || !root.isConnected) return;
        if (Date.now() < nextAllowedAt) throw new Error('throttled');
        const url = new URL(root.dataset.productUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('origin');
        url.searchParams.delete('variant');
        const currentUrl = new URL(location.href);
        for (const key of ['preview_theme_id', 'pb']) if (currentUrl.searchParams.has(key)) url.searchParams.set(key, currentUrl.searchParams.get(key));
        url.searchParams.set('section_id', root.dataset.sectionId);
        url.searchParams.set('option_values', optionIds.join(','));
        const response = await fetch(url, {credentials: 'same-origin', signal: requestController.signal, headers: {'Accept': 'text/html'}});
        if (response.status === 429) {
          nextAllowedAt = Date.now() + Math.max(5000, (Number(response.headers.get('Retry-After')) || 5) * 1000);
        }
        if (!response.ok) throw new Error('response');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (current !== revision || !root.isConnected) return;
        const rendered = [...doc.querySelectorAll('[data-shop-product]')].find(node => node.dataset.productId === root.dataset.productId);
        if (!rendered || rendered.dataset.variantResolver !== 'server') throw new Error('product');
        const selectedIds = [...rendered.querySelectorAll('[data-native-option-position] input:checked')].map(input => input.dataset.nativeOptionId);
        if (selectedIds.length !== optionIds.length || selectedIds.some((value, index) => value !== optionIds[index])) throw new Error('options');
        const variants = JSON.parse(rendered.querySelector('[data-shop-variants]').textContent);
        if (!Array.isArray(variants) || variants.length > 1) throw new Error('variants');
        const variant = variants[0];
        if (variant && (!variant.id || variant.options?.length !== inputs.length || variant.options.some((value, index) => String(value) !== inputs[index].value))) throw new Error('combination');
        root.dataset.variantLoading = 'false';
        root.querySelector('[data-shop-variants]').textContent = JSON.stringify(variants);
        id.value = variant ? String(variant.id) : '';
        const pageUrl = new URL(location.href);
        pageUrl.searchParams.delete('variant');
        pageUrl.searchParams.set('option_values', optionIds.join(','));
        history.replaceState({}, '', pageUrl);
        publish(variants);
        if (variant) root.dispatchEvent(new CustomEvent('cover11:variant-selected', {detail: variant}));
        status.textContent = variant ? '' : (messages.select_option || '');
      } catch (_) {
        if (current !== revision || !root.isConnected) return;
        root.dataset.variantLoading = 'false';
        publish([]);
        status.textContent = messages.network_error || '';
        retry.hidden = false;
        if (Date.now() < nextAllowedAt) {
          retry.disabled = true;
          setTimeout(() => { if (current === revision) retry.disabled = false; }, nextAllowedAt - Date.now());
        }
      } finally {
        clearTimeout(timeout);
        if (current === revision) {
          root.dataset.variantLoading = 'false';
          root.removeAttribute('aria-busy');
        }
      }
    }
    groups.forEach(group => group.addEventListener('change', update));
    retry.addEventListener('click', update);
    window.addEventListener('pagehide', () => controller?.abort(), {once: true});
  }
  const mount = () => document.querySelectorAll('[data-shop-product]').forEach(init);
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
